import React from 'react';

import { Col, Row } from 'reactstrap';
import { Flex, FlexRow, Navbar } from '../components';
import BaseLayout from '../components/Layouts/BaseLayout';
import useNavigationScroller from '../hooks/useNavigationScroller';
import LargeBar from '../components/Bars/LargeBar';

import PartnersFooter from '../components/PartnersFooter/PartnersFooter';
import { Link } from 'gatsby';
import Markdown from '../components/Markdown/Markdown';
import blogDataJson from '../data/blog.json';
import SideDiamond from '../components/SideDiamond/SideDiamond';

export const BlogPageInternal = (blogData: typeof blogDataJson) => {
  const wrapper = React.useRef<HTMLDivElement>(null);
  useNavigationScroller(wrapper);

  return (
    <BaseLayout title="Info & Insights">
      <Navbar />

      <Row className="flex-fill">
        <Col md={4}></Col>
        <Col className="d-flex flex-column p-3 flex-fill" md={8}>
          <div className="pt-2 px-2">
            <Link to="/">
              <img className="img-fluid hero-opacity" src={require('../images/logo-horizontal.svg').default} alt="Aviation Safety Solutions" style={{ height: '20vh' }} />
            </Link>
          </div>
        </Col>
      </Row>

      <div className="wrapper" ref={wrapper}>
        <Row>
          <Col className="d-none d-md-block" md={4}>
            <Flex center className="side-affix">
              <SideDiamond label={<span>Info<br/>&<br/>Insights</span>} icon={null} />
            </Flex>
          </Col>
          <Col md={7}>
            <section className="px-2 pt-5 body-bg">
              {
                blogData.entries.map((entry, i) => (
                  <Link key={i} to={`/blog/${entry.slug}`}>
                    <Row key={i} className="mb-5">
                      <Col md={12}>
                        <h2 className="serif mb-1" style={{ lineHeight: 1.5 }}>{entry.title}</h2>
                        <h4 className="text-secondary">{entry.date}</h4>
                      </Col>
                      <Col md={3}>
                        <div style={{ maxWidth: 200 }}>
                          <img className="img-fluid" src={entry.image} alt={entry.title} />
                        </div>
                      </Col>
                      <Col md={9}>
                        <div className="fade-bottom">
                          <Markdown source={entry.content} />
                        </div>

                        <div className="text-secondary">
                          <h4 className="serif text-secondary">Read More</h4>
                        </div>
                      </Col>
                    </Row>
                  </Link>
                ))
              }
            </section>
          </Col>
        </Row>

        <div className="hero-opacity my-1 mt-5 text-center">
          <LargeBar style={{ width: '60%' }} />
        </div>

        <section className="pt-5">
          <PartnersFooter />
        </section>

        <div className="hero-opacity mt-3 pb-5 text-center text-secondary">
          <FlexRow justifyCenter childSpacingX={1}>
            <i className="mdi mdi-36px mdi-star" />
            <i className="mdi mdi-36px mdi-star" />
            <i className="mdi mdi-36px mdi-star" />
            <i className="mdi mdi-36px mdi-star" />
            <i className="mdi mdi-36px mdi-star" />
          </FlexRow>
        </div>
      </div>
    </BaseLayout>
  );
};

export default () => <BlogPageInternal {...blogDataJson} />;
